var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { BaseReportItemComponent } from 'app/reports/models/base-report-item-component';
var FlaggedQuestionsListComponent = /** @class */ (function (_super) {
    __extends(FlaggedQuestionsListComponent, _super);
    function FlaggedQuestionsListComponent() {
        var _this = _super.call(this) || this;
        _this._questionsByAssessments = new Map();
        return _this;
    }
    FlaggedQuestionsListComponent.prototype.ngOnInit = function () {
    };
    FlaggedQuestionsListComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    /**
     * data => {
     * 'assessments' => [
     *   'assessment: 'dass-21', 'scale': '88....'
     *  ]
     * }
     * @param data
     * @param results
     * @param variables
     */
    FlaggedQuestionsListComponent.prototype.setReportData = function (data, results, variables) {
        var _this = this;
        if (!data || !results) {
            return;
        }
        this._itemTitle = data.title;
        this._description = data.description;
        if (data.assessments) {
            this._assessments = [];
            var assessments = data.assessments.forEach(function (c) {
                var result = results.find(function (r) { return r.assessment.uid == c; });
                if (!result) {
                    return;
                }
                var questions = result.assessment.getFlaggedQuestions();
                if (questions.length) {
                    _this._questionsByAssessments.set(result.assessment, questions);
                    _this._assessments.push(result.assessment);
                }
            });
        }
    };
    FlaggedQuestionsListComponent.prototype.shouldPrintBreak = function (index) {
        // since index is 0 based the the user scales per page is 1 based we convert.
        return ((index + 1) == this._scales_per_page);
    };
    Object.defineProperty(FlaggedQuestionsListComponent.prototype, "ScalesPerPage", {
        get: function () {
            return this._scales_per_page;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlaggedQuestionsListComponent.prototype, "Assessments", {
        get: function () {
            return this._assessments;
        },
        enumerable: true,
        configurable: true
    });
    FlaggedQuestionsListComponent.prototype.getQuestionsForAssessment = function (assessment) {
        return this._questionsByAssessments.get(assessment);
    };
    Object.defineProperty(FlaggedQuestionsListComponent.prototype, "hasFocusQuestions", {
        get: function () {
            return this._questionsByAssessments.size > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlaggedQuestionsListComponent.prototype, "description", {
        get: function () {
            return this._description;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlaggedQuestionsListComponent.prototype, "title", {
        get: function () {
            return this._itemTitle;
        },
        enumerable: true,
        configurable: true
    });
    return FlaggedQuestionsListComponent;
}(BaseReportItemComponent));
export { FlaggedQuestionsListComponent };



// WEBPACK FOOTER //
// ./src/app/reports/report-items/flagged-questions-list/flagged-questions-list.component.ts.pre-build-optimizer.js